import BISApuestatotalService from "./partners/apuestatotal";
import BISBonanzaService from "./partners/bonanza";

const bisAdapter = {
  apuestatotal: BISApuestatotalService,
  bonanza: BISBonanzaService,
};

class BISService {
  static token = null;

  static authorize = (token) => {
    this.token = token;
  }

  static validate = (partnerName, body, options = {}) => {
    const service = bisAdapter[partnerName];
    return service?.validate(this.token, body, options);
  };

  static createBet = (partnerName, body) => {
    const service = bisAdapter[partnerName];
    return service?.createBet(this.token, body);
  };

  static payBet = (partnerName, body) => {
    const service = bisAdapter[partnerName];
    return service?.payBet(this.token, body);
  };
}

export default BISService;
